export const GET_LIST = "GET_LIST";
export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";
export const UPDATE_PHOTO_SOURCE = "UPDATE_PHOTO_SOURCE";
export const ADD_PHOTO = "ADD_PHOTO";
export const RENAME_PHOTO = "RENAME_PHOTO";
export const DELETE_PHOTO = "DELETE_PHOTO";
export const SET_LOADER = "SET_LOADER";